// Placeholder for shadcn/ui toaster component
export const Toaster = () => null;

